<template>
  <div class="template-editor">
    <h2>{{ title }}</h2>
    <div
      id="editor"
      ref="editor"
      :style="`height: ${height}px`"
      v-html="value"
    ></div>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  props: {
    title: {
      type: String
    },
    value: {
      type: String
    },
    height: {
      type: String
    },
    content: {
      type: Object
    }
  },

  data() {
    return {
      editor: null
    };
  },
  mounted() {
    var BackgroundClass = Quill.import("attributors/class/background");
    var ColorClass = Quill.import("attributors/class/color");
    var SizeStyle = Quill.import("attributors/style/size");
    var inlineStyle = Quill.import("attributors/style/align");
    Quill.register(inlineStyle, true);
    Quill.register(SizeStyle, true);
    Quill.register(ColorClass, true);
    Quill.register(BackgroundClass, true);

    this.editor = new Quill(this.$refs.editor, {
      modules: {
        toolbar: [
          [{ font: [] }],
          [{ header: [1, 2, 3, 4, false] }],
          ["bold", "italic", "underline", "strike"],
          ["image", "link"],
          ["blockquote"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }], // superscript/subscript
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [
            { align: "" },
            { align: "center" },
            { align: "right" },
            { align: "justify" }
          ],
          ["clean"]
        ]
      },
      theme: "snow"
    });
    // this.editor.root.innerHTML = this.value;
    this.editor.on("text-change", () => this.update());
    this.editor.setContents(this.content, "api");
  },
  methods: {
    update() {
      this.$emit("change", this.editor.getContents());
      this.$emit(
        "input",
        this.editor.getText() ? this.editor.root.innerHTML : ""
      );
    }
  }
};
</script>

<style scoped>
.template-editor h2 {
  font-style: normal;
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 25px;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  color: var(--ink-900);
}
/* Set default font-family */
#editor {
  font-family: var(--font-sans);
  font-size: var(--fs-body);
}
.my-custom-tag {
  display: inline;
}
</style>
